export default __webpack_public_path__ + "static/media/indtech_fms2.99212142.jpg";